/**
 * User Status Constants
 * Centralized user status mappings for the application
 */

export const USER_STATUS = {
  PendingValidation: 'Aguardando aprovação',
  Active: 'Aprovada',
  PendingAffiliation: 'Sem filiação',
  AffiliationInProgress: 'Filiação em andamento'
};

export const USER_STATUS_KEYS = {
  PENDING_VALIDATION: 'PendingValidation',
  ACTIVE: 'Active',
  PENDING_AFFILIATION: 'PendingAffiliation',
  AFFILIATION_IN_PROGRESS: 'AffiliationInProgress'
};

/**
 * Logical order for status sorting (lower number = appears first)
 * This helps ensure statuses are sorted in a meaningful way
 */
export const USER_STATUS_ORDER = {
  Active: 1,
  PendingValidation: 2,
  AffiliationInProgress: 3,
  PendingAffiliation: 4
};

